var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"no-margin row",class:{
        'justify-content-center':
          !_vm.user || (_vm.user && _vm.user.default_department == null),
      }},[_c('div',{staticClass:"full-width",class:_vm.authenticated ? _vm.rClass : _vm.loginClass},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }